/* eslint-disable max-lines */
import React, { useState } from 'react';
import IModule from 'models/IModule';
import { downloadCertifProgram } from 'actions/CertificateProgram';
import DataTable from 'react-data-table-component';
import Category from 'models/Category';
import formatSessionsDetails from 'helpers/formatSessionsDetails';
import Theme from 'models/Theme';
import Modal from 'components/Modal';
import { useCandidate } from 'hooks/useCandidate';
import { useHistory } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { mecansimTypesEnum } from 'constants/types/mecanism';
import { setSelectedCertificate } from 'actions/Certificate/setSelectCerificate';
import { ModuleEnum } from 'constants/types/Module';
import CandidatePresenceTable from 'components/CandidatePresenceTable';
import { IFormattedSessionAttendance } from 'view-models/SessionViewModel';
import { fetchCandidateAttendanceList, saveCandidatePresence } from 'actions';
import Candidate from 'models/Candidate';
import { RootState } from 'reducers';
import { CandInterfaceEnum } from 'constants/types/candidates';
import columns from './columns';
export interface IProps {
  moduleWithSessions?: IModule;
  downloadProgramFile: () => void;
}

const ViewCertificatesAboutSection: React.FC<IProps> = ({
  moduleWithSessions,
}) => {
  const [selectedSession, setSelectedSession] = useState<
    IFormattedSessionAttendance
  >();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { downloadCondiadatesFile, currentCandidates } = useCandidate(
    'Certificate',
  );
  const { candidateWithAttendance } = useSelector(
    (state: RootState) => state.candidates,
  );
  const togglePresence = () => setIsModalOpen(!isModalOpen);
  const dispatch = useDispatch();
  const history = useHistory();
  const handlePresence = (session: IFormattedSessionAttendance) => {
    setSelectedSession(session);
    dispatch(
      fetchCandidateAttendanceList({
        sessionId: session.id,
        candidateList: currentCandidates,
      }),
    );
    togglePresence();
  };
  const cols = columns(
    downloadCondiadatesFile,
    moduleWithSessions as IModule,
    false,
    false,
    handlePresence,
  );
  const formattedData = formatSessionsDetails(moduleWithSessions?.session);

  const handleEdit = () => {
    dispatch({ type: mecansimTypesEnum.TOGGLE_EDIT_CERTIFICATE });
    dispatch({
      type: ModuleEnum.ADD_MODULE_SUCCESS,
      payload: moduleWithSessions,
    });
    dispatch(setSelectedCertificate(moduleWithSessions?.certificate));
    history.push('/addtraining');
  };
  const downloadProgramFile = () => {
    dispatch(downloadCertifProgram(moduleWithSessions?.certificate?.id));
  };
  const handleSavePresence = (selectedCandidate: Candidate[]) => {
    const absentCandidate = currentCandidates.filter(
      el =>
        !selectedCandidate.some(e => {
          return e.id === el.id;
        }),
    );
    selectedSession &&
      dispatch(
        saveCandidatePresence(
          selectedSession,
          selectedCandidate,
          absentCandidate,
        ),
      );
    dispatch({ type: CandInterfaceEnum.RESET_CANDIDATE_ATTENDANCE_LIST });
    togglePresence();
  };
  return (
    <div className="col-8 p-1 abf-sidebar mt-lg-n8">
      <Modal
        title="Reporting présence"
        isOpen={isModalOpen}
        closeModal={() => setIsModalOpen(false)}
        className="modal-xl"
      >
        {currentCandidates?.length > 0 && (
          <CandidatePresenceTable
            candidates={candidateWithAttendance || currentCandidates}
            handleSavePresence={handleSavePresence}
          />
        )}
      </Modal>
      {moduleWithSessions && (
        <div className="card mb-3 mb-lg-5">
          <div className="card-header">
            <div className="row align-items-center">
              <div className="col">
                <div className="d-none d-lg-block">
                  <h4 className="card-title">Informations générales</h4>
                </div>
              </div>
              <div className="col-auto">
                <div className="d-none d-lg-block">
                  <button
                    type="button"
                    onClick={handleEdit}
                    className="btn btn-sm btn-soft-primary"
                  >
                    Modifier
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="card-body">
            <div className="row form-group">
              <span className="col-auto m-0 h5 font-weight">Semestre :</span>
              <span className="col-auto h5 m-0 font-weight">
                {moduleWithSessions?.certificate?.title}
              </span>
              <div className="ml-auto" style={{ marginRight: '15px' }}>
                <button
                  type="button"
                  className="btn btn-sm btn-soft-dark"
                  onClick={downloadProgramFile}
                >
                  Télécharger fiche programme
                </button>
              </div>
            </div>
            <div className="row form-group">
              <span className="col-auto h5 m-0 font-weight">Module :</span>
              <span className="col-auto h5 m-0 font-weight">
                {moduleWithSessions?.title}
              </span>
            </div>
            <div className="row form-group">
              <span className="col-auto mb-1 mt-3 mr-2 h5 font-weight">
                Thème :
              </span>
              <span className="col-auto mb-1 mt-3 mr-2 h5 font-weight">
                {(moduleWithSessions?.certificate?.theme as Theme).title}
              </span>
            </div>
            <div className="row form-group">
              <span className="col-auto mb-1 mt-3 mr-2 h5 font-weight">
                Catégorie :
              </span>
              <span className="col-auto mb-1 mt-3 mr-2 h5 font-weight">
                {(moduleWithSessions?.certificate?.category as Category).title}
              </span>
            </div>
            <div className="row form-group">
              <span className="col-auto mb-1 mt-3 mr-2 h5 font-weight">
                Séances :
              </span>
              <div className="col-9">
                {formattedData && (
                  <DataTable
                    data={formattedData}
                    columns={cols}
                    noHeader
                    persistTableHead
                    subHeaderAlign="center"
                    expandOnRowClicked
                    highlightOnHover
                    noDataComponent="Aucun élément"
                    pagination
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ViewCertificatesAboutSection;
